import { Component, OnInit, Input, Output, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

import { UniqueIdService } from '@shared/services/unique-id.service';
import { CompanyService } from '@shared/http/company.service';
import { DocUtils } from '@shared/utils/docs.utils';
import { SFCompany } from '@shared/models/Company';
import { User } from '@shared/models/User';

@Component({
  selector: 'ottimizza-company-selector',
  templateUrl: './company-input.component.html',
  styleUrls: ['./company-input.component.scss']
})
export class CompanyInputComponent implements OnInit {

  @Input()
  public identifier = '';

  @Output()
  public companySelected = new EventEmitter<SFCompany>();

  public selectableCompanies: SFCompany[] = [];
  public selectedCompany: SFCompany;

  @ViewChild('empresa', { static: true })
  private companyInput: ElementRef<HTMLInputElement>

  private currentUser = User.fromLocalStorage();

  constructor(
    private uniqueIdService: UniqueIdService,
    private companyService: CompanyService
  ) { }

  ngOnInit(): void {
    if (!this.identifier) {
      this.identifier = this.uniqueIdService.generateWithPrefix('company-input')
    }
    // this.onInputCompany('');
  }

  public onInputCompany(c: string) {
    this.companyService.fetch({ nomeCompleto: c, pageSize: 5 }).subscribe(res => {
      this.selectableCompanies = res.records;
        // console.log(this.currentUser.organization);
        // this.selectableCompanies.push({
        //   codigoERP: this.currentUser.organization.codigoERP,
        //   razaoSocial: this.currentUser.organization.name,
        //   cnpj: this.currentUser.organization.cnpj,
        // } as any);
    });
    if (c === '') {
        this.companySelected.emit(null);
    }
  }

  public getEmpresaDisplayName(company: SFCompany): string {
    if (company === undefined) {
      return '';
    }
    const dn = `${(company.Codigo_Empresa_ERP__C && company.Codigo_Empresa_ERP__C !== 'null') ? company.Codigo_Empresa_ERP__C + ' - ' : ''}${company.Name || ''}`.toUpperCase().trim();
    return dn;
  }

  public getEmpresaDisplayCnpj(company: SFCompany): string {
    return DocUtils.format(company.CNPJ__c);
  }

  public select(event: MatAutocompleteSelectedEvent) {
    this.selectedCompany =  event.option.value as SFCompany;
    this.companyInput.nativeElement.value = this.getEmpresaDisplayName(this.selectedCompany);
    this.companySelected.emit(this.selectedCompany);
  }

}
